<template>
  <div>
    <guide-use title="手机号画像-在线API版本"></guide-use>
    <div class="risk-phone-list">
      <ul class="list-header">
        <li v-for="(item, index) in headerData" :key="index">{{item}}</li>
      </ul>
      <div class="list-body" v-for="(item,index) in phoneProduct" :key="index">
        <span>{{toThousands(item['reqtotal'])}}次</span>
        <span>{{toThousands(item['reqtotal'] - item['reqused'])}}次</span>
        <span>{{item.ctime}}</span>
        <span>{{item.expire}}</span>
      </div>
    </div>
    <chart-phone></chart-phone>
  </div>
</template>

<script>
import chartPhone from './chart/index.vue'
import guideUse from '../../../components/mark/guideUse'
import { toThousands } from '../../../util/common'
export default {
  name: 'riskPhoneOnline',
  components: { chartPhone, guideUse },
  data () {
    return {
      headerData: ['授权配额', '剩余配额', '开通时间', '截止时间']
    }
  },
  methods: {
    toThousands
  },
  computed: {
    phoneProduct () {
      return this.$store.state.product.filter(val => {
        return val.busi === 'heika_online' && val.auditflag === '5'
      })
    }
  }
}
</script>

<style lang="scss">
.risk-phone-list {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 4px 8px 0 rgba(17, 39, 98, 0.04);
  border-radius: 4px;

  .list-header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(234, 237, 242, 1);

    li {
      display: inline-block;
      width: 20%;
      height: 58px;
      line-height: 58px;
      font-size: 16px;
      font-weight: 500;
      color: rgba(29, 36, 60, 1);
      text-align: center;
    }
  }

  .list-body {
    display: flex;
    justify-content: space-between;
    span {
      display: inline-block;
      width: 20%;
      text-align: center;
      height: 75px;
      line-height: 75px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(29, 36, 60, 1);
      .feedback {
        width: 72px;
        height: 28px;
        background: rgba(0, 61, 146, 1);
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 28px;
        cursor: pointer;
      }
    }
  }
}
</style>
